/**
 * Kalkulator BCS (Body Condition Score) — test 4-pytaniowy.
 *
 * Scoring client-side: sumuje odpowiedzi (ribs/waist/abdomen/external)
 * i mapuje na skalę 1-9. Opisy i rekomendacje localizowane z PHP
 * (window.hnBcs — single source of truth: hn_bcs_describe / hn_bcs_recommendations).
 *
 * Zapis wyniku do profilu zwierzaka: POST /wp-json/hn/v1/bcs/save (zalogowani).
 */

const CFG = window.hnBcs || {};

// Mapa: suma odpowiedzi (0–13) → BCS 1–9. Pasmo idealne = suma 5–7.
const SUM_TO_BCS = [1, 2, 3, 3, 4, 5, 5, 5, 6, 6, 7, 8, 9, 9];

function escHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
}

function escAttr(value) {
    return String(value == null ? '' : value).replace(/"/g, '&quot;');
}

export function initBcs() {
    const wizard = document.querySelector('[data-hn-bcs-quiz]');
    if (!wizard) {
        return;
    }
    const result = wizard.querySelector('[data-hn-bcs-result]');
    const progressBar = wizard.querySelector('[data-hn-bcs-progress]');
    const steps = Array.from(wizard.querySelectorAll('.hn-sub-step[data-step]'));
    const petsInput = document.querySelector('[data-hn-bcs-pets]');
    const TOTAL = steps.length;
    let current = 1;

    let pets = [];
    if (petsInput && petsInput.value) {
        try {
            pets = JSON.parse(petsInput.value) || [];
        } catch (error) {
            pets = [];
        }
    }

    async function saveScore(score) {
        const select = result.querySelector('[data-hn-bcs-pet-select]');
        const message = result.querySelector('[data-hn-bcs-save-msg]');
        const button = result.querySelector('[data-hn-bcs-save]');
        if (!select || !CFG.saveUrl) {
            return;
        }
        if (button) button.disabled = true;
        try {
            const response = await fetch(CFG.saveUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': CFG.nonce || '' },
                body: JSON.stringify({ pet_id: parseInt(select.value, 10), score }),
            });
            const data = await response.json();
            if (response.ok && data && data.saved) {
                if (message) { message.textContent = '✓ Zapisano w profilu pupila.'; message.style.color = '#16a34a'; }
            } else {
                if (message) {
                    message.textContent = (data && data.message) || 'Nie udało się zapisać.';
                    message.style.color = '#dc2626';
                }
            }
        } catch (error) {
            if (message) { message.textContent = 'Błąd połączenia.'; message.style.color = '#dc2626'; }
        } finally {
            if (button) button.disabled = false;
        }
    }

    function render(score) {
        if (!result) {
            return;
        }
        const info = (CFG.describe && CFG.describe[score]) || { label: '', color: '#64748b', desc: '' };
        const band = score <= 3 ? 'thin' : (score >= 6 ? 'overweight' : 'ideal');
        const recommendations = (CFG.recommendations && CFG.recommendations[band]) || [];

        let html = '<div class="hn-bcs-result__card">';
        html += '<div class="hn-bcs-result__header">';
        html += '<div class="hn-bcs-result__score" style="background:' + escAttr(info.color) + '">' +
            '<strong>' + score + '</strong><span>/ 9</span></div>';
        html += '<div><h3>' + escHtml(info.label) + '</h3><p>' + escHtml(info.desc) + '</p></div>';
        html += '</div>';

        if (recommendations.length) {
            html += '<ul class="hn-bcs-result__recs">';
            recommendations.forEach((rec) => {
                html += '<li><strong>' + escHtml(rec.title) + '</strong>' +
                    '<p>' + escHtml(rec.desc) + '</p>';
                if (rec.link) {
                    html += '<a href="' + escAttr(rec.link) + '">Zobacz →</a>';
                }
                html += '</li>';
            });
            html += '</ul>';
        }

        if (CFG.loggedIn && pets.length) {
            html += '<div class="hn-bcs-result__save"><h4>Zapisz wynik w profilu pupila</h4>';
            html += '<select data-hn-bcs-pet-select>';
            pets.forEach((pet) => {
                html += '<option value="' + escAttr(pet.id) + '">' + escHtml(pet.name) + '</option>';
            });
            html += '</select>';
            html += '<button type="button" class="hn-btn hn-btn--primary" data-hn-bcs-save>Zapisz</button>';
            html += '<p class="hn-bcs-result__save-msg" data-hn-bcs-save-msg></p></div>';
        } else if (!CFG.loggedIn) {
            html += '<div class="hn-bcs-result__login">Zaloguj się, aby zapisać wynik ' +
                'w profilu pupila i śledzić kondycję w czasie.</div>';
        }
        html += '</div>';

        // Restart link — pozwala przejść test ponownie bez reload strony.
        html += '<button type="button" class="hn-sub-result__restart" data-hn-bcs-restart>↻ Zrób test ponownie</button>';

        // Steps + progress chowamy gdy wynik widoczny.
        steps.forEach((s) => { s.hidden = true; });
        if (progressBar && progressBar.parentElement) progressBar.parentElement.hidden = true;

        result.hidden = false;
        result.innerHTML = html;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const saveButton = result.querySelector('[data-hn-bcs-save]');
        if (saveButton) {
            saveButton.addEventListener('click', () => saveScore(score));
        }
        const restartButton = result.querySelector('[data-hn-bcs-restart]');
        if (restartButton) {
            restartButton.addEventListener('click', () => {
                wizard.querySelectorAll('input[type="radio"]:checked').forEach((r) => { r.checked = false; });
                result.hidden = true;
                result.innerHTML = '';
                if (progressBar && progressBar.parentElement) progressBar.parentElement.hidden = false;
                showStep(1);
            });
        }
    }

    /**
     * Pokaż krok N (1-indexed), ukryj resztę, zaktualizuj progress bar.
     */
    function showStep(n) {
        current = Math.max(1, Math.min(TOTAL, n));
        steps.forEach((s) => {
            s.hidden = parseInt(s.dataset.step, 10) !== current;
        });
        if (progressBar) {
            progressBar.style.width = ((current / TOTAL) * 100) + '%';
        }
        wizard.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    /**
     * Zbierz odpowiedzi → policz BCS → render. Gdy któryś krok pusty (np. user
     * cofnął i wyczyścił) — wraca do pierwszego brakującego.
     */
    function computeAndRender() {
        const fields = ['ribs', 'waist', 'abdomen', 'external'];
        let sum = 0;
        for (let i = 0; i < fields.length; i += 1) {
            const checked = wizard.querySelector('input[name="' + fields[i] + '"]:checked');
            if (!checked) {
                showStep(i + 1);
                return;
            }
            sum += parseInt(checked.value, 10);
        }
        sum = Math.max(0, Math.min(SUM_TO_BCS.length - 1, sum));
        render(SUM_TO_BCS[sum]);
    }

    // Auto-advance — wybór opcji przechodzi do następnego kroku (lub wyniku).
    // 260ms delay — user widzi że jego wybór się zaznaczył zanim slide.
    wizard.addEventListener('change', (event) => {
        const radio = event.target;
        if (!radio.matches || !radio.matches('input[type="radio"]')) return;

        const step = radio.closest('.hn-sub-step');
        if (!step) return;
        // Zaznaczenie wybranej opcji stylizuje CSS przez `:has(input:checked)`.

        const stepNum = parseInt(step.dataset.step, 10);
        setTimeout(() => {
            if (stepNum < TOTAL) {
                showStep(stepNum + 1);
            } else {
                computeAndRender();
            }
        }, 260);
    });

    // Wstecz.
    wizard.addEventListener('click', (event) => {
        if (event.target.closest('[data-hn-bcs-back]')) {
            event.preventDefault();
            showStep(current - 1);
        }
    });
}
